import "./history-page.less"
import Layout from "../layouts/layout"
import { useMessages } from "../language/language"
import { ErrorAlert } from "../components/alert"
import { Link } from "react-router-dom"
import HistoryReportSummary from "./history-report-summary"
import PercentageList from "../components/percentage-list"
import { useEffect } from "react"
import { usePlayState } from "play/hooks/use-play-state"
import { serverGetReportsForCurrentStudent } from "utils/server"
import { computeStatsForStudent } from "models/reports-compute-stats"

export default function HistoryPage() {
  const msg = useMessages()
  const { serverError, history, modifyState } = usePlayState()
  const { pageIndex, stats } = history

  useEffect(() => {
    document.title = msg.pageTitle(msg.pageTitleHistory)
  }, [])

  useEffect(() => {
    modifyState((state) => {
      state.internalPage = "Loading"
      state.loadingReason = "Loading"
      state.serverError = null
    })

    serverGetReportsForCurrentStudent({ page: pageIndex || 0 })
      .then((result) => {
        modifyState((state) => {
          state.internalPage = null
          state.loadingReason = null
          state.serverError = null
          state.history.page = result
          state.history.pageIndex = pageIndex || 0

          const user = state.loggedUser
          if (!user) {
            console.error("user not logged in")
            return
          }
          if (!user.id) {
            console.error("user has no student id")
          }

          state.history.stats = result.items.map((report) => ({
            report: report,
            stats: computeStatsForStudent(report, {
              userId: user.id,
              name: state.fullName!,
            }),
          }))
        })
      })
      .catch((e) => {
        modifyState((state) => {
          state.internalPage = null
          state.loadingReason = null
          state.serverError = "Generic"
          state.serverErrorData = e
        })
      })
  }, [pageIndex])

  return (
    <Layout
      timerEnabled={false}
      screenCounterEnabled={false}
      scrollingEnabled={true}
      nextEnabled={false}
      prevEnabled={false}
      pointsEnabled={false}
      logoIsLink={true}
    >
      <div className="history-page">
        <ErrorAlert error={msg.serverErrorToString(serverError)} />
        <p className="breadcrumb">
          <Link to="/">{msg.back}</Link>
        </p>
        <h1 className="dot">{msg.pageTitleHistory}</h1>
        <PercentageList>
          {stats.map((report) => (
            <HistoryReportSummary
              key={report.report.id}
              report={report}
              expandable={true}
            />
          ))}
        </PercentageList>
      </div>
    </Layout>
  )
}
